import { BodyText } from '@/components/BodyText';
import { TitleText } from '@/components/TitleText';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails, AccordionSummary, Alert } from '@mui/material';
import { StyledServiceAccountAccordion } from './ServiceAccountCard';

export const ServiceAccountErrorState = () => {
  return (
    <StyledServiceAccountAccordion defaultExpanded={true}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <TitleText>My Service Account</TitleText>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity='error'>
          <BodyText>Failed to load service account information</BodyText>
        </Alert>
      </AccordionDetails>
    </StyledServiceAccountAccordion>
  );
};
